import { atoms } from 'helpers/atoms';
import { useAtomValue } from 'jotai';
import { FC } from 'react';
import styles from './loginbutton.module.scss';

interface LoginButtonProps {}
export const LoginButton: FC<LoginButtonProps> = () => {
  const keycloak = useAtomValue(atoms.auth.keycloakInstance);
  let idpHint;
  if (window.AUTH_IDP_HINT === true) idpHint = 'eherkenning';
  if (typeof window.AUTH_IDP_HINT === 'string' && window.AUTH_IDP_HINT === 'true') idpHint = 'eherkenning';

  return (
    <div style={{ marginTop: '8px' }}>
      <span style={{ color: '#1CB052', fontSize: 14 }}>Inloggen met: </span>
      <img className={styles.button} onClick={() => keycloak.login({ idpHint })} style={{ height: 50, cursor: 'pointer' }} src="/eHerkenning_logo.png" />
    </div>
  );
};
